import * as React from "react";
import ReactDOM from "react-dom";
import { useHistory } from "react-router-dom";
import AppBar from "@mui/material/AppBar";
import {
  Box,
  Tooltip,
  Typography,
  Toolbar,
  IconButton,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import MenuIcon from "@mui/icons-material/Menu";
import OutsideClickHandler from "react-outside-click-handler";
import { Images } from '../../assets/common';
import {
  getUserDetail,
  logout,
  getUserId,
  fullName,
  truncate,
  updateUserDetail,
  isOwnerId,
  hasPremium,
} from '../../constants/function';
import "./index.scss";
import Balance from "../Balance";
import ProfileMenu from "../ProfileMenu";
import Notifications from "../../pages/Notifications";
import Search from "../../pages/Search";
import ApiService from "./../../services/api-service";
import { useDispatch, useSelector } from "react-redux";
import { clearSong } from "../../action/songs";
import { getErrorString } from "./../../constants/function";
import { useContext } from "react";
import { SocketContext } from "../../context/socket";
import { hideChat } from "./../../action/chat";
import { startStream } from "../../action/stream";
import { useTranslation } from "react-i18next";
import Geocode from "react-geocode";
import { Close } from "@mui/icons-material";
import ProfileBorder from "./ProfileBorder";
import { getBalance } from "../../asyncAction/asyncBalance";
import { Flags } from 'react-feature-flags';
import StreamHeader from '../Stream/AudiencCardContainer/StreamHeader';
import emitter from '../../EventEmitter';
import { useTheme as useAppTheme } from '../../context/ThemeContext';
import ChatIcon from '../icons/ChatIcon';
import NotificationIcon from '../icons/NotificationIcon';
import WalletIcon from '../icons/WalletIcon';

const fallbackLogo = require('../../assets/common/resources/SIKI_Beta.png');
const MAX_UNREAD_MESSAGES = 50;

Geocode.setApiKey(process.env.REACT_APP_GOOGLE_KEY);
Geocode.setLanguage("en");

export default function Header({ currentScreenWidth,
  isJoined, tokenData, songData,
  toggleNav, isChatOpen, setIsChatOpen, isFullScreen }) {
  const { t, i18n } = useTranslation("common");
  const {
    streamData,
    obs,
  } = useSelector((state) => state.stream);

  const userId = getUserId();
  const { Socket, setSocket } = useContext(SocketContext);
  const dispatch = useDispatch();
  const history = useHistory();
  const userDetail = getUserDetail();
  const [showNotification, setShowNotification] = React.useState(false);
  const [isProfileMenuOpen, setIsProfileMenuOpen] = React.useState(false);
  const [unreadCount, setUnreadCount] = React.useState(0);
  const [msgs, setMsgs] = React.useState([]);
  const [showSearchBar, setShowSearchBar] = React.useState(true);
  const [isLongSearchBar, setIsLongSearchBar] = React.useState(true);
  const [showWalletButtons, setShowWalletButtons] = React.useState(true);
  const [isStreaming, setIsStreaming] = React.useState(false);
  const isOpen = React.useRef(null);
  const [isOwner, setIsOwner] = React.useState(false);
  const watchers = useSelector((state) => state.liveUsers || []);
  const { streamCount } = useSelector((state) => state.streamCount);
  const { getCurrentBranding, currentThemeName } = useAppTheme();
  const brandingDefaults = { logo: fallbackLogo, logoAlt: 'SIKI Logo' };
  const currentBranding = getCurrentBranding ? getCurrentBranding() : brandingDefaults;
  const headerBranding = {
    ...brandingDefaults,
    ...currentBranding,
  };
  const isCompactHeader = currentScreenWidth <= 600;
  const isCompactSearchOpen = isCompactHeader && showSearchBar;
  const showBranding = !(isCompactHeader && showSearchBar);



  const handleProfileClick = (event) => {
    setIsProfileMenuOpen(!isProfileMenuOpen);
  };

  const handleProfileClose = () => {
    setIsProfileMenuOpen(false);
  };

  const handleProfileMenuChoice = (key) => {
    handleProfileClose();
    switch (key) {
      case "m11":
          emitter.emit( "hideStream" );
          history.push("/app/Profile");
        break;
      case "m21":
          emitter.emit( "hideStream" );
          history.push(`/app/ArtistProfile/${userId}`);
        break;
      case "m13":
        emitter.emit( "endtream" );
        Socket.close();
        setSocket(null);
        dispatch(clearSong());
        logout();
        history.push("/");
        break;
      case "m18":
        history.push("/PrivacyPolicy");
        break;
      case "m19":
        history.push("/TermsCondition");
        break;
      case "m20":
        history.push("/HowToUse");
        break;
      default:
        break;
    }
  };

  const markSeen = async (path, notificationId, seen) => {
    history.push(path);
    if (!seen) {
      try {
        await ApiService.MARK_SEEN({
          notificationId: notificationId,
          status: "seen",
        });
      } catch (error) {
      }
    }
  };

  const getUnreadCount = async () => {
    try {
      const response = await ApiService.UNREAD();
      if (response["result"][0]) {
        setUnreadCount(response["result"][0]["count_unread_notifications"]);
      }
    } catch (error) {
    }
  };

  const updateUserDetails = async () => {
    try {
      const response = await ApiService.USER_PROFILE();
      localStorage.setItem(
        "streamingBalance",
        response.result.streamingBalance
      );
      updateUserDetail(response["result"]);
    } catch (error) {
    }
  };

  React.useEffect(() => {
    setIsOwner( isOwnerId(streamData?.owner) );
    getUnreadCount();
    if (userDetail && !userDetail.hasPremium) updateUserDetails();
    if (!userDetail.country) {
      getLocation();
    }
  }, [streamData]);

  function getLocation() {
    if (navigator.geolocation) {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(showPosition);
      }
    }
  }

  function showPosition(position) {
    Geocode.fromLatLng(
      position.coords.latitude,
      position.coords.longitude
    ).then(
      (response) => {
        let country;
        for (
          let i = 0;
          i < response.results[0].address_components.length;
          i++
        ) {
          for (
            let j = 0;
            j < response.results[0].address_components[i].types.length;
            j++
          ) {
            switch (response.results[0].address_components[i].types[j]) {
              case "country":
                country = response.results[0].address_components[i].long_name;
                break;
            }
          }
        }
        if (country) {
          country
            .toLowerCase()
            .split(" ")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ");

          updateProfile(country);
        }
      },
      (error) => {
        console.error(error);
      }
    );

    const updateProfile = async (country) => {
      try {
        const formData = new FormData();
        formData.append("country", country);
        const response = await ApiService.UPDATE_USER(formData);
        updateUserDetail(response["result"]);
    } catch (error) {
    }
  };
  }

  const getPlaylistDetail = async (channelName) => {
    try {
      const response = await ApiService.PLAYLIST_DETAIL({
        _id: channelName,
        pageNo: 1,
        pageSize: 1,
      });
      dispatch(
        startStream({
          streamData: response?.result,
          title: null,
          goal: null,
        })
      );
    } catch (error) {
    }
  };

  React.useEffect(() => {
    // Browser notification for new message
    //NOTE:safari issue
    // if (!Notification) {
    //   alert(
    //     "Desktop notifications not available in your browser. Try Chromium."
    //   );
    //   return;
    // }
    // if (Notification.permission !== "granted") Notification.requestPermission();
    if (!Socket) return;
    const handleMessageReceived = (msg) => {
        if (msg["senderUserId"] === userId) {
          setMsgs((previous) => [...previous, msg].slice(-MAX_UNREAD_MESSAGES));
          // Browser notification
          // if (!isOpen.current) {
          //   var notification = new Notification(
          //     `New message from ${msg["user"]["firstName"]}`,
          //     {
          //       icon:
          //         msg["user"]["profileImg"] &&
          //         msg["user"]["profileImg"]["filePath"]
          //           ? msg["user"]["profileImg"]["filePath"]
          //           : Images.user_dummy,
          //       body: truncate(msg["message"], 25),
          //     }
          //   );
          //   notification.onclick = function () {
          //     setMsgs([]);
          //     handleOpenChat();
          //   };
          // }
        }
    };
    const handleUpdateBalance = (data) => {
        if (data.update) {
          dispatch(getBalance());
        }
    };
    const handleBalanceUpdated = (data) => {
        if (data?.result?._id === userId) {
          dispatch(getBalance());
        }
    };
    Socket.on("message_received", handleMessageReceived);
    Socket.on("update-balance", handleUpdateBalance);
    Socket.on("balanceUpdated", handleBalanceUpdated);

      //   //Showing notification to followers if user start livestream
      //   // Socket.on("stream-joined", function (data) {
      //   //   if (data && data.followers && data.followers.length > 0 && !isStream) {
      //   //     const index = data.followers.indexOf(userId);
      //   //     if (index >= 0) {
      //   //       const fullname = fullName(data);
      //   //       var notification = new Notification(` ${fullname} has gone live`, {
      //   //         icon: data?.profileImg?.filePath || Images.streaming,
      //   //         // body: "Click to join the live streaming",
      //   //       });
      //   //       // notification.onclick = function () {
      //   //       //   getPlaylistDetail(data.channelName);
      //   //       // };
      //   //     }
      //   //   }
      //   // });
    return () => {
      Socket.off("message_received", handleMessageReceived);
      Socket.off("update-balance", handleUpdateBalance);
      Socket.off("balanceUpdated", handleBalanceUpdated);
    };
  }, [Socket]);

  const handleOpenChat = React.useCallback(() => {
      emitter.emit( "hideStream" );
      setIsChatOpen(true);
  }, [setIsChatOpen]);

  React.useEffect(() => {
    if (isChatOpen) {
      setMsgs([]);
    }
    isOpen.current = isChatOpen;
  }, [isChatOpen]);

  React.useEffect(() => {
    setIsStreaming( tokenData?.token );
    // Always show search bar when screen is wide enough, regardless of streaming status
    setShowSearchBar( currentScreenWidth > 600 );
    setIsLongSearchBar( currentScreenWidth > 800 );
    setShowWalletButtons( !tokenData?.token && currentScreenWidth > 800 );
  }, [currentScreenWidth,tokenData]);

  React.useEffect(() => {
    const openChatFromDrawer = () => {
      setMsgs([]);
      handleOpenChat();
      dispatch(hideChat(true));
    };

    const openNotificationsFromDrawer = () => {
      setShowNotification(true);
    };

    emitter.on("openDrawerChat", openChatFromDrawer);
    emitter.on("openDrawerNotifications", openNotificationsFromDrawer);

    return () => {
      emitter.off("openDrawerChat", openChatFromDrawer);
      emitter.off("openDrawerNotifications", openNotificationsFromDrawer);
    };
  }, [dispatch, handleOpenChat]);

  return (
      <Box id="headerBox"
      sx={{
        background: "rgba(8, 8, 12, 0.9)",
        backdropFilter: "blur(24px)",
        flexGrow: 1,
        height: currentScreenWidth <= 800 ? "80px" : "64px",
        display: "flex",
        alignItems: "center",
        boxShadow: "none",
        borderBottom: "1px solid var(--hud-border)",
        position: "fixed",
        width: "100%",
        top: 0,
        zIndex: 1300
      }}
      className="__app_header"
    >
      <AppBar id="appBar"
        sx={{
          background: "transparent",
          boxShadow: "none",
          position: "fixed",
          top: 0,
          zIndex: 1400,
          fontFamily: "var(--font-display)",
        }}
          >

          <Toolbar sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: isCompactHeader ? 1 : 0,
            flexWrap: 'nowrap',
            minHeight: isCompactHeader ? '80px' : '64px',
            paddingTop: isCompactHeader ? '8px' : '0px',
            paddingBottom: isCompactHeader ? '8px' : '0px',
            paddingLeft: '12px',
          }}>
            { currentScreenWidth > 600 ? null : (
                <Tooltip title="Open navigation menu">
                  <IconButton
                      size="large"
                edge="start"
                color="inherit"
                aria-label="menu"
                sx={{ mr: 1 }}
                onClick={toggleNav}
              >
                <MenuIcon />
              </IconButton>
            </Tooltip>
          )}

          {showBranding ? (
            <Box
              id="brandingContainer"
              sx={{ 
                display: "flex", 
                alignItems: "center", 
                marginLeft: 0,
                flexShrink: isCompactHeader ? 1 : 0,
                flexWrap: 'nowrap',
                maxWidth: isCompactHeader ? "35%" : "auto",
                minWidth: isCompactHeader ? 0 : "auto",
                overflow: "hidden",
                columnGap: isCompactHeader ? 0.5 : 1
              }}
            >
              <Box
                id="appLogo"
                sx={{ 
                  display: "flex", 
                  alignItems: "center", 
                  flexShrink: 0,
                  maxWidth: isCompactHeader ? "120px" : "auto",
                  overflow: "hidden"
                }}
              >
                <Flags
                  authorizedFlags={["v3-full", "v3-navBar"]}
                  renderOn={() =>
                    <img
                      src={headerBranding.logo}
                      alt={headerBranding.logoAlt}
                      onClick={() => emitter.emit("goHome")}
                      className="___header_logo _cp"
                      style={{ cursor: "pointer", height: isCompactHeader ? "28px" : "32px", width: "auto", display: "block" }}
                    />
                  }
                  renderOff={() =>
                    <img
                      src={headerBranding.logo}
                      alt={headerBranding.logoAlt}
                      onClick={() => emitter.emit("goHome")}
                      className="___header_logoV2 _cp"
                      style={{ cursor: "pointer", height: isCompactHeader ? "28px" : "32px", width: "auto", display: "block" }}
                    />
                  }
                />
                {currentThemeName === 'memehouse' && (
                  <Typography
                    onClick={() => emitter.emit("goHome")}
                    sx={{
                      fontFamily: "'Nexa Bold', 'Montserrat', sans-serif",
                      fontWeight: 700,
                      fontSize: '24px',
                      color: (theme) => theme.palette.primary.main,
                      letterSpacing: '1px',
                      cursor: 'pointer',
                      userSelect: 'none',
                      whiteSpace: 'nowrap',
                      marginLeft: '-145px',
                      flexShrink: 0,
                      display: isCompactHeader ? 'none' : 'block'
                    }}
                  >
                    MEMEHOUSE MUSIC
                  </Typography>
                )}
              </Box>
              { currentThemeName !== 'siki' && (
                <Typography
                  variant="caption"
                  sx={{
                    ml: isCompactHeader ? 0.5 : 1,
                    fontSize: '10px',
                    color: (theme) => theme.palette.text.secondary,
                    letterSpacing: '.5px',
                    textTransform: 'none',
                    whiteSpace: 'nowrap',
                    flexShrink: isCompactHeader ? 1 : 0,
                    display: isCompactHeader ? 'none' : 'inline'
                  }}
                >
                  powered by SIKI
                </Typography>
              )}
            </Box>
          ) : null}


            <Flags authorizedFlags={["v3-full", "v3-liveFull"]}
                   renderOn={ () =>
                       isStreaming ? (
                       <StreamHeader
                           title={streamData?.title}
                           watchers={watchers}
                           aggregatorCount={streamCount}
                  isOwner={isOwner}
                  isJoined={isJoined}
                  playlistId={streamData._id}
                  streamSong={songData}
                  obs={obs}
                  isFullScreen={isFullScreen}
                />
              ) : null
            }
          />

          <Box id="searchBox"
            sx={{
              display: "flex",
              flex: isCompactSearchOpen ? "1 1 100%" : isCompactHeader ? "0 0 auto" : 1,
              alignItems: "center",
              justifyContent: isCompactSearchOpen || !isCompactHeader ? "center" : "flex-start",
              minWidth: isCompactSearchOpen ? 0 : 0,
              maxWidth: isCompactSearchOpen ? '100%' : isCompactHeader ? '0px' : "800px",
              mx: isCompactSearchOpen ? 1 : isCompactHeader ? 0 : 2,
              width: isCompactSearchOpen ? '100%' : isCompactHeader ? '0px' : 'auto',
              paddingLeft: isCompactHeader ? 0 : '0px',
              paddingRight: isCompactHeader ? 0 : '0px',
              opacity: isCompactSearchOpen || !isCompactHeader ? 1 : 0,
              pointerEvents: isCompactSearchOpen || !isCompactHeader ? 'auto' : 'none'
                 }}
            >
              { showSearchBar && isLongSearchBar ? <Search /> : null }

              { showSearchBar && !isLongSearchBar ? (
                  <Box
                      sx={{
                        display: "flex",
                  alignItems: "center",
                  width: "100%"
                }}
              >
                <Search
                  showClose={
                    <IconButton onClick={() => {
                      setShowSearchBar(false);
                    }}>
                      <Close />
                    </IconButton>
                        }
                    />
                  </Box>
              ) : null }
            </Box>

            <Box id="iconBar"
            className="__header_left_items"
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              marginLeft: "auto",
              marginRight: isCompactHeader ? "12px" : "20px"
            }}
          >
            {isCompactHeader && !showSearchBar ? (
              <IconButton
                onClick={() => {
                  setShowSearchBar(true);
                }}
                sx={{ mr: 1 }}
              >
                <SearchIcon />
              </IconButton>
            ) : null}

            {!isCompactHeader && (
              <>
                <Box sx={{ position: 'relative' }}>
                  <IconButton
                    id="chatIcon"
                    onClick={() => {
                      setMsgs([]);
                      handleOpenChat();
                      dispatch(hideChat(true));
                    }}
                    sx={{
                      width: '52px',
                      height: '52px',
                      borderRadius: '14px',
                      background: '#161616',
                      border: '1px solid rgba(255,255,255,0.07)',
                      transition: 'all 0.2s cubic-bezier(0.34, 1.56, 0.64, 1)',
                      '&:hover': {
                        background: '#1c1c1c',
                        borderColor: 'rgba(245,208,0,0.3)',
                        transform: 'scale(1.06)',
                        boxShadow: '0 8px 24px rgba(0,0,0,0.4), 0 0 0 1px rgba(245,208,0,0.1)',
                        '& svg path, & svg line': {
                          stroke: '#F5D000'
                        }
                      }
                    }}
                  >
                    <ChatIcon active={isChatOpen} />
                  </IconButton>
                  {msgs.length > 0 && !isChatOpen ? (
                    <Box
                      id="chatActive"
                      sx={{
                        position: 'absolute',
                        top: '9px',
                        right: '9px',
                        width: '7px',
                        height: '7px',
                        borderRadius: '50%',
                        background: '#F5D000',
                        border: '1.5px solid #0A0A0A',
                        boxShadow: '0 0 6px rgba(245,208,0,0.6)',
                      }}
                    />
                  ) : null}
                </Box>

                <Box sx={{ position: 'relative' }}>
                  <IconButton
                    id="notificationIcon"
                    onClick={() => setShowNotification(!showNotification)}
                    sx={{
                      width: '52px',
                      height: '52px',
                      borderRadius: '14px',
                      background: showNotification ? 'rgba(245,208,0,0.08)' : '#161616',
                      border: showNotification ? '1px solid rgba(245,208,0,0.35)' : '1px solid rgba(255,255,255,0.07)',
                      transition: 'all 0.2s cubic-bezier(0.34, 1.56, 0.64, 1)',
                      '&:hover': {
                        background: '#1c1c1c',
                        borderColor: 'rgba(245,208,0,0.3)',
                        transform: 'scale(1.06)',
                        boxShadow: '0 8px 24px rgba(0,0,0,0.4), 0 0 0 1px rgba(245,208,0,0.1)',
                        '& svg path': {
                          stroke: '#F5D000'
                        }
                      }
                    }}
                  >
                    <NotificationIcon active={showNotification} hasNotifications={unreadCount > 0} />
                  </IconButton>
                  {unreadCount > 0 ? (
                    <Box
                      sx={{
                        position: 'absolute',
                        top: '9px',
                        right: '9px',
                        width: '7px',
                        height: '7px',
                        borderRadius: '50%',
                        background: '#F5D000',
                        border: '1.5px solid #0A0A0A',
                        boxShadow: '0 0 6px rgba(245,208,0,0.6)',
                      }}
                    />
                  ) : null}
                </Box>

                <IconButton
                  onClick={() => {
                    emitter.emit("hideStream");
                    history.push("/app/Wallet");
                  }}
                  sx={{
                    width: '52px',
                    height: '52px',
                    borderRadius: '14px',
                    background: '#161616',
                    border: '1px solid rgba(255,255,255,0.07)',
                    transition: 'all 0.2s cubic-bezier(0.34, 1.56, 0.64, 1)',
                    '&:hover': {
                      background: '#1c1c1c',
                      borderColor: 'rgba(245,208,0,0.3)',
                      transform: 'scale(1.06)',
                      boxShadow: '0 8px 24px rgba(0,0,0,0.4), 0 0 0 1px rgba(245,208,0,0.1)',
                      '& svg path, & svg rect': {
                        stroke: '#F5D000'
                      },
                      '& svg rect[fill]': {
                        fill: '#F5D000'
                      }
                    }
                  }}
                >
                  <WalletIcon />
                </IconButton>
              </>
            )}

                <Box
                      id="userProfileIcon"
              onClick={handleProfileClick}
              className="_cp"
              sx={{
                position: "relative",
                width: "60px",
                height: "60px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
              }}
            >
              <ProfileBorder
                        progress={userDetail["percentage"]}
                        style={{ position: "absolute" }}
                    />
                    <img
                        style={{
                  objectFit: "cover",
                  position: "absolute",
                  width: "42px",
                  height: "37px",
                  clipPath:
                    "polygon(25% 0%, 75% 0%, 100% 50%, 75% 99%, 25% 99%, 0% 50%)",
                  backgroundColor: "var(--accent-color, #1e1e1e)",
                  zIndex: 1
                }}
                src={
                  userDetail["profileImg"] &&
                    userDetail["profileImg"]["filePath"] != ""
                    ? userDetail["profileImg"]["filePath"]
                    : ""
                }
                alt="user profile"
              />
            </Box>
          </Box>

        </Toolbar>
      </AppBar>

      {isProfileMenuOpen && ReactDOM.createPortal(
        <Box sx={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 999999998, pointerEvents: 'none' }}>
          <Box sx={{ pointerEvents: 'auto', position: 'absolute', top: '5px', right: '10px' }}>
            <OutsideClickHandler
              onOutsideClick={() => {
                handleProfileClose();
              }}
            >
              <ProfileMenu
                isLast={"65px !important"}
                right={"0px"}
                actions={[
                  { key: "m21", action: "My Profile" },
                  { key: "m11", action: "Profile Settings" },
                  { key: "m13", action: t("dropMenu.m13") },
                  { key: "divider", action: null },
                  { key: "m20", action: "How to Use" },
                  { key: "m18", action: "Privacy Policy" },
                  { key: "m19", action: "Terms of Service" },
                ]}
                handleProfileMenuChoice={(item) => handleProfileMenuChoice(item)}
                handleClick={() => handleProfileClose()}
                isHeader={true}
              />
            </OutsideClickHandler>
          </Box>
        </Box>,
        document.body
      )}

      {showNotification && ReactDOM.createPortal(
        <Box sx={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 999999999, pointerEvents: 'none' }}>
          <Box sx={{ pointerEvents: 'auto' }}>
            <OutsideClickHandler onOutsideClick={() => setShowNotification(false)}>
              <Notifications
                onClick={(path, id, seen) =>
                  path ? (setShowNotification(false), markSeen(path, id, seen)) : ""
                }
                notificationShow={setShowNotification}
                setUnreadCnt={setUnreadCount}
                unreadCnt={unreadCount}
                openChat={(e) => {
                  setMsgs([]);
                  handleOpenChat();
                }}
              />
            </OutsideClickHandler>
          </Box>
        </Box>,
        document.body
      )}
    </Box>
  );
}
